import { useState, type FormEvent } from 'react';
import {
  useToolCall, PlatformSelect, GenerateButton, CopyButton, LimitReached, ResultFunnel, ErrorNote,
  type ToolPlatform,
} from './aiToolShared';

export function HashtagGenerator() {
  const [topic, setTopic] = useState('');
  const [platform, setPlatform] = useState<ToolPlatform>('instagram');
  const { run, loading, error, limitReached, data } = useToolCall<{ hashtags: string[] }>('/api/tools/hashtags');

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (topic.trim().length < 2) return;
    run({ topic: topic.trim(), platform });
  }

  return (
    <div>
      <form onSubmit={onSubmit} className="space-y-4">
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Tema o descripción de tu post</span>
          <input
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            maxLength={400}
            placeholder="Ej.: receta fácil de pasta para el verano"
            className="mt-1 w-full rounded-xl border border-slate-300 px-3.5 py-3 text-slate-900 focus:border-brand-500 focus:ring-2 focus:ring-brand-200 outline-none"
          />
        </label>
        <PlatformSelect value={platform} onChange={setPlatform} />
        <GenerateButton loading={loading} label="Generar hashtags" />
      </form>

      {error && <ErrorNote message={error} />}
      {limitReached && <div className="mt-6"><LimitReached /></div>}

      {data && data.hashtags.length > 0 && !limitReached && (
        <ResultFunnel>
          <div className="rounded-xl border border-slate-200 bg-white p-4">
            <div className="flex items-center justify-between gap-3">
              <span className="text-sm font-semibold text-slate-900">{data.hashtags.length} hashtags</span>
              <CopyButton text={data.hashtags.join(' ')} />
            </div>
            <div className="mt-3 flex flex-wrap gap-2">
              {data.hashtags.map((h, i) => (
                <span key={i} className="rounded-full bg-brand-50 px-3 py-1 text-sm text-brand-700">{h}</span>
              ))}
            </div>
          </div>
        </ResultFunnel>
      )}
    </div>
  );
}
